import { styled } from "sharedUI/styles";
import { BaseScreenStyle } from "../../../ui/views/base-screen/base-screen-style";

export const MembersScreenStyle = styled(BaseScreenStyle)`
    max-width: 1280px;

    .mems-trans-appear {
        opacity: 0;
    }

    .mems-trans-appear-active {
        opacity: 1;
        transition: opacity 200ms;
    }

    .mems-entry-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;

        input {
            flex: 1;
            padding: 0 12px;
            margin-right: 16px;
            height: 36px;
            background-color: ${p => p.theme.formControlBg};
            color: ${p => p.theme.fgColorDark};
            border-radius: 8px;
            transition: all ${p => p.theme.transitionBase};

            &:hover {
                background-color: ${p => p.theme.formControlBgHover};
            }

            &:focus {
                box-shadow: 0 0 0 1px ${p => p.theme.b400};
            }
        }

        button {
            flex: 0 0 auto;
            height: 36px;
            padding: 6px 16px;
            background-color: ${p => p.theme.accentPrimary};
            border-radius: 8px;
            color: #fff;
            font-weight: 600;
            cursor: pointer;

            :disabled {
                opacity: 0.4;
                pointer-events: none;
            }
        }
    }

    .mems-grid-header {
        border-top: 1px solid ${p => p.theme.borderPale};
        color: ${p => p.theme.textPale};
        font-weight: 600;
        height: 40px;

        &:first-child {
            color: ${p => p.theme.textBase};
        }
    }

    .mems-grid-row {
        position: relative;
        display: grid;
        grid-template-columns: 2fr 2fr 1fr 1fr 64px;
        grid-column-gap: 8px;
        grid-auto-rows: 48px;
        align-items: center;
        padding: 0 16px 0 20px;
        background-color: transparent;
        transition: background-color ${p => p.theme.transitionBase};

        &:not(.mems-grid-header):hover {
            background-color: ${p => p.theme.bgColorAltLight};
        }

        & > div {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &:last-child {
            margin-bottom: 12px;
        }
    }

    .mems-grid-row.admin {
        grid-template-columns: 2fr 2fr 1fr 1fr 78px 64px;
    }

    .mems-remove-button {
        color: ${p => p.theme.textDanger};
        font-weight: 500;
        align-self: stretch;
        transition: all ${p => p.theme.transitionBase};
        cursor: pointer;

        :hover & {
            opacity: 1;
        }

        &.btn-ghost {
            display: none;
            opacity: 0;
        }
    }

    .mems-admin-button {
        color: ${p => p.theme.blue};
        font-weight: 500;
        align-self: stretch;
        transition: all ${p => p.theme.transitionBase};
        cursor: pointer;
        opacity: 0.4;

        :hover {
            opacity: 1;
        }
    }

    .mems-grid-row:hover .btn-ghost {
        display: block;
        opacity: 1;
    }

    .mems-user-wrapper {
        display: flex;
        align-items: center;
    }

    .mems-user-photo {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        object-fit: cover;
        border-radius: 100px;
        background-color: ${p => p.theme.bgColorMedium};
    }

    .mems-admin {
        font-weight: 600;
    }

    .mems-warning {
        display: inline-flex;
        color: ${p => p.theme.textXpale};

        p {
            color: ${p => p.theme.textPale};
            margin-left: 8px;
        }
    }
`;
